let initialBasePrice = 0;
const VAT = 0.25;
let optionsUpdateFunctions = null; // Globala referenser till runOptionsPage-funktioner

// --- Hjälpfunktioner ---
function formatThousands(num) {
  return Number.isFinite(num) ? Math.round(num).toLocaleString('sv-SE') : num;
}

function extractPrice(text) {
  const match = text.match(/[\d\s\.,]+/);
  if (!match) return null;
  return parseFloat(match[0].replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
}

// --- Uppdatera alla standardpriser ---
function updateAllPrices() {
  const mode = localStorage.getItem('vatMode') || 'inkl';
  if (window.location.pathname.startsWith('/checkout')) return;

  document.querySelectorAll('.price-item').forEach(el => {
    if (!el.dataset.originalPrice) {
      const price = extractPrice(el.textContent);
      if (price) el.dataset.originalPrice = price; // alltid inkl moms
    }
    if (!el.dataset.originalPrice) return;

    let price = parseFloat(el.dataset.originalPrice);
    if (mode === 'exkl') price = Math.round(price / (1 + VAT));
    el.textContent = formatThousands(price) + (mode === 'exkl' ? ' SEK exkl. moms' : ' SEK inkl. moms');
  });

  // Varukorgspriser
  document.querySelectorAll('.cart-item__price-wrapper .price').forEach(el => {
    if (!el.dataset.originalPrice) {
      const price = extractPrice(el.textContent);
      if (price) el.dataset.originalPrice = price;
    }
    if (!el.dataset.originalPrice) return;

    let price = parseFloat(el.dataset.originalPrice);
    if (mode === 'exkl') price = Math.round(price / (1 + VAT));
    el.textContent = formatThousands(price) + (mode === 'exkl' ? ' kr exkl. moms' : ' kr inkl. moms');
  });

  // Varukorgsoptions (dd-element)
  document.querySelectorAll('.cart-item__details dd').forEach(dd => {
    // Spara originaltext FÖRSTA gången
    if (!dd.dataset.originalText) {
      dd.dataset.originalText = dd.textContent;
    }
    
    if (!dd.dataset.originalPrice) {
      const match = dd.dataset.originalText.match(/([\d\s\.,]+)\s*kr/i);
      if (match) {
        const price = extractPrice(match[1]);
        if (dd.dataset.originalText.includes('exkl')) {
          dd.dataset.originalPrice = Math.round(price * (1 + VAT));
        } else {
          dd.dataset.originalPrice = price;
        }
      }
    }
    if (!dd.dataset.originalPrice) return;

    let price = parseFloat(dd.dataset.originalPrice);
    if (mode === 'exkl') price = Math.round(price / (1 + VAT));
    
    const newPrice = formatThousands(price) + (mode === 'exkl' ? ' kr exkl. moms' : ' kr inkl. moms');
    
    // Använd ALLTID originalText för att ersätta
    dd.textContent = dd.dataset.originalText.replace(
      /([\d\s\.,]+)\s*kr(\s*(exkl|inkl)\. moms)?/i, 
      newPrice
    );
  });
}

// --- Paketpris ---
function updatePackagePrice() {
  const el = document.querySelector('.price-item.price-item--regular');
  if (!el || document.querySelector('.infiniteoptions-price')) return;

  if (!el.dataset.originalPrice) el.dataset.originalPrice = extractPrice(el.textContent);
  if (!el.dataset.originalPrice) return;

  const mode = localStorage.getItem('vatMode') || 'inkl';
  let price = parseFloat(el.dataset.originalPrice);
  if (mode === 'exkl') price = Math.round(price / (1 + VAT));
  el.textContent = formatThousands(price) + (mode === 'exkl' ? ' SEK exkl. moms' : ' SEK inkl. moms');
}

// --- Cart-knapp ---
function updateCartButtonPrice() {
  if (document.querySelector('.infiniteoptions-price')) return;

  const btnSpan = Array.from(document.querySelectorAll('button.product-form__submit span'))
    .find(s => s && !s.classList.contains('loading__spinner') && /SEK|kr/.test(s.textContent));
  const pkg = document.querySelector('.price-item.price-item--regular');
  if (!btnSpan || !pkg || !pkg.dataset.originalPrice) return;

  const mode = localStorage.getItem('vatMode') || 'inkl';
  let price = parseFloat(pkg.dataset.originalPrice);
  if (mode === 'exkl') price = Math.round(price / (1 + VAT));

  const prefixMatch = btnSpan.textContent.replace(/\u00A0/g, ' ').match(/^([\s\S]*?)-\s*/);
  const prefix = prefixMatch ? prefixMatch[1].trim() + ' -' : 'Lägg i varukorgen -';
  btnSpan.textContent = prefix + ' ' + formatThousands(price) + ' SEK' + 
    (mode === 'exkl' ? ' exkl. moms' : ' inkl. moms');
}

// --- Infinite Options ---
function waitForInfiniteOptions(callback) {
  const check = () => {
    const priceEl = document.querySelector('.infiniteoptions-price .price-item');
    const checkboxes = document.querySelectorAll('input[type="checkbox"][value*="kr"]');
    if (priceEl && priceEl.textContent.match(/\d/) && checkboxes.length > 0) setTimeout(callback, 150);
    else setTimeout(check, 100);
  };
  check();
}

function runOptionsPage() {
  waitForInfiniteOptions(() => {
    const originalCheckboxValues = new Map();
    const originalSelectValues = new Map();

    // Spara baspris
    const priceEl = document.querySelector('.infiniteoptions-price .price-item');
    if (priceEl && !priceEl.dataset.originalPrice) {
      const price = extractPrice(priceEl.textContent);
      if (price) {
        priceEl.dataset.originalPrice = price;
        initialBasePrice = price;
      }
    } else if (priceEl) {
      initialBasePrice = parseFloat(priceEl.dataset.originalPrice);
    }

    // --- Uppdatera options ---
    function updateOptions() {
      const mode = localStorage.getItem('vatMode') || 'inkl';

      // Checkboxar
      document.querySelectorAll('input[type="checkbox"][value*="kr"]').forEach(cb => {
        if (!originalCheckboxValues.has(cb)) originalCheckboxValues.set(cb, cb.value);
        const original = originalCheckboxValues.get(cb);
        const match = original.match(/\(([\d\s\.,]+) kr\)$/);
        if (!match) return;

        let price = extractPrice(match[1]);
        if (mode === 'exkl') price = Math.round(price / (1 + VAT));

        const itemName = original.replace(/\([\d\s\.,]+ kr\)$/, '').trim();
        const suffix = mode === 'exkl' ? 'kr exkl. moms' : 'kr inkl. moms';
        cb.value = `${itemName} (${formatThousands(price)} ${suffix})`;

        const label = cb.parentElement;
        if (label) {
          const textNodes = Array.from(label.childNodes).filter(n => n.nodeType === 3);
          if (textNodes.length) textNodes[textNodes.length - 1].textContent = ` ${itemName} (${formatThousands(price)} ${suffix})`;
        }
      });

      // Select-optioner
      document.querySelectorAll('select option[value*="kr"]').forEach(option => {
        if (!originalSelectValues.has(option)) originalSelectValues.set(option, option.value);
        const original = originalSelectValues.get(option);
        const match = original.match(/\(([\d\s\.,]+) kr\)$/);
        if (!match) return;

        let price = extractPrice(match[1]);
        if (mode === 'exkl') price = Math.round(price / (1 + VAT));

        const itemName = original.replace(/\([\d\s\.,]+ kr\)$/, '').trim();
        const suffix = mode === 'exkl' ? 'kr exkl. moms' : 'kr inkl. moms';
        option.value = `${itemName} (${formatThousands(price)} ${suffix})`;
        option.textContent = option.value;
      });
    }

    // --- Beräkna totalpris ---
    function calculateTotal() {
      const mode = localStorage.getItem('vatMode') || 'inkl';
      if (mode === 'inkl') {
        document.body.classList.remove('hide-original-price');
        const custom = document.getElementById('custom-total-price');
        if (custom) custom.textContent = '';
        return;
      }

      let total = initialBasePrice ? Math.round(initialBasePrice / (1 + VAT)) : 0;

      // Lägg till checkbox-priser
      document.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        if (cb.id === 'vatToggle') return;
        const original = originalCheckboxValues.get(cb);
        if (!original) return;
        const match = original.match(/\(([\d\s\.,]+) kr\)$/);
        if (match) total += Math.round(extractPrice(match[1]) / (1 + VAT));
      });

      const priceVisible = document.querySelector('.infiniteoptions-price .price-item');
      if (priceVisible) priceVisible.textContent = formatThousands(total) + ' SEK exkl. moms';

      const custom = document.getElementById('custom-total-price');
      if (custom) custom.textContent = formatThousands(total) + ' SEK exkl moms';
      document.body.classList.add('hide-original-price');
    }

    // --- Exportera globalt ---
    optionsUpdateFunctions = { updateOptions, calculateTotal };

    // --- Events ---
    document.addEventListener('change', e => {
      if ((e.target.matches('input[type="checkbox"]') && e.target.id !== 'vatToggle') ||
          e.target.matches('select')) {
        updateOptions();
        calculateTotal();
        updateAllPrices();
      }
    });

    const toggle = document.getElementById('vatToggle');
    if (toggle) {
      toggle.checked = (localStorage.getItem('vatMode') || 'inkl') === 'inkl';
      toggle.addEventListener('change', function() {
        localStorage.setItem('vatMode', this.checked ? 'inkl' : 'exkl');
        updateOptions();
        calculateTotal();
        updateAllPrices();
      });
    }

    // Flytta custom-price
    const custom = document.getElementById('custom-total-price');
    const container = document.querySelector('.infiniteoptions-price');
    if (custom && container) container.appendChild(custom);

    // Kör initial
    updateOptions();
    calculateTotal();
    updateAllPrices();
  });
}

// --- Init ---
document.addEventListener('DOMContentLoaded', () => {
  const isOptions = !!document.querySelector('.infiniteoptions-price');

  if (isOptions) runOptionsPage();
  else {
    updateAllPrices();
    updatePackagePrice();
    updateCartButtonPrice();

    const toggle = document.getElementById('vatToggle');
    if (toggle) {
      toggle.checked = (localStorage.getItem('vatMode') || 'inkl') === 'inkl';
      toggle.addEventListener('change', function() {
        localStorage.setItem('vatMode', this.checked ? 'inkl' : 'exkl');
        updateAllPrices();
        updatePackagePrice();
        updateCartButtonPrice();
      });
    }
  }
});

// --- Observer för nya element ---
const observer = new MutationObserver(mutations => {
  for (const m of mutations) {
    if (m.addedNodes.length && [...m.addedNodes].some(n => n.nodeType === 1 && n.querySelector && n.querySelector('.price-item'))) {
      setTimeout(updateAllPrices, 100);
      break;
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// --- Popup momsval ---
document.addEventListener('DOMContentLoaded', function() {
  const vatSwitcher = document.getElementById('vat-switcher');
  const vatPopup = document.getElementById('vat-popup');
  const vatToggle = document.getElementById('vatToggle');
  const privateBtn = document.getElementById('vat-private');
  const businessBtn = document.getElementById('vat-business');

  if (!vatSwitcher || !vatPopup || !vatToggle || !privateBtn || !businessBtn) return;

  // Visa popup om inget val finns
  if (!localStorage.getItem('vatMode')) {
    vatPopup.style.display = 'block';
    vatSwitcher.style.display = 'none';
  } else {
    if (!window.location.pathname.startsWith('/checkout')) vatSwitcher.style.display = 'flex';
  }

  // Klick på Privat
  privateBtn.onclick = function() {
    localStorage.setItem('vatMode', 'inkl');
    vatToggle.checked = true;
    vatPopup.style.display = 'none';
    if (!window.location.pathname.startsWith('/checkout')) vatSwitcher.style.display = 'flex';

    updateAllPrices();
    updatePackagePrice();
    updateCartButtonPrice();
    if (optionsUpdateFunctions) {
      optionsUpdateFunctions.updateOptions();
      optionsUpdateFunctions.calculateTotal();
    }
  };

  // Klick på Företag
  businessBtn.onclick = function() {
    localStorage.setItem('vatMode', 'exkl');
    vatToggle.checked = false;
    vatPopup.style.display = 'none';
    if (!window.location.pathname.startsWith('/checkout')) vatSwitcher.style.display = 'flex';

    updateAllPrices();
    updatePackagePrice();
    updateCartButtonPrice();
    if (optionsUpdateFunctions) {
      optionsUpdateFunctions.updateOptions();
      optionsUpdateFunctions.calculateTotal();
    }
  };
});